export default {"src":"/_next/static/media/menu.de495ea7.svg","height":67,"width":68,"blurWidth":0,"blurHeight":0};